import React from 'react';
import { Title } from '@gjensidige/builders-components';

interface ISectionHeaderProps {
  wrapperClass: string;
  headerText: string;
}

export const SectionHeader: React.FC<ISectionHeaderProps> = (
  props: ISectionHeaderProps
) => {
  return (
    <>
      <div className={props.wrapperClass}>
        <Title as="h2" size="4">{props.headerText}</Title>
      </div>
    </>
  );
};
